import { useId, useState } from 'react'
import { ago, fmtStamp, scansOf } from './trackingUtils'

const COLLAPSED = 4

/** Courier scans, newest first, collapsed to four with a show-all toggle. */
export default function TrackingTimeline({ shipment }) {
  const [showAll, setShowAll] = useState(false)
  const listId = useId()
  const scans = scansOf(shipment)
  const visible = showAll ? scans : scans.slice(0, COLLAPSED)

  return (
    <section aria-labelledby={`${listId}-title`}>
      <div className="flex items-baseline justify-between gap-3 mb-4">
        <h3 id={`${listId}-title`} className="text-xs text-primary/40 tracking-widest">
          Courier Updates
        </h3>
        {shipment.updated_at && <span className="text-[11px] text-primary/30 tracking-wider normal-case">Updated {ago(shipment.updated_at)}</span>}
      </div>

      {scans.length === 0 ? (
        <p className="text-sm text-primary/50 normal-case">No courier scans yet. They usually appear within a day of pickup.</p>
      ) : (
        <>
          <ol id={listId} className="relative border-l-2 border-border/60 ml-2 space-y-5">
            {visible.map((s, i) => (
              <li key={`${s.when}-${i}`} className="pl-5 relative">
                <span
                  className={`absolute -left-1.75 top-1.5 w-3 h-3 rounded-full border-2 ${i === 0 ? 'bg-secondary border-secondary' : 'bg-white border-gray-300'}`}
                  aria-hidden="true"
                ></span>
                <p className={`text-sm normal-case ${i === 0 ? 'text-primary font-semibold' : 'text-primary/70'}`}>{s.text || 'Update'}</p>
                <p className="text-xs text-primary/40 normal-case mt-0.5">
                  {s.location && <span>{s.location} · </span>}
                  {s.when && <time dateTime={s.when}>{fmtStamp(s.when)}</time>}
                </p>
              </li>
            ))}
          </ol>
          {scans.length > COLLAPSED && (
            <button
              type="button"
              onClick={() => setShowAll((v) => !v)}
              aria-expanded={showAll}
              aria-controls={listId}
              className="mt-4 ml-7 text-xs font-bold tracking-widest text-secondary hover:text-primary transition-colors"
            >
              {showAll ? 'SHOW LESS' : `SHOW ALL ${scans.length} UPDATES`}
            </button>
          )}
        </>
      )}
    </section>
  )
}
